const CONSTANTS = {
  SSO_COOKIE_NAME: 'sso_token_wimo',
  MAX_RESULTS: 20,
};

export default CONSTANTS;



// WEBPACK FOOTER //
// src/configs/constants.js